// extracted by mini-css-extract-plugin
module.exports = {"title":"Customers_title__1edGB","logos":"Customers_logos__3AEZN","img":"Customers_img__2vVUc"};